import $ from 'jquery'

$.fn.cookieBar = function(options) {
  const settings = $.extend({
    'acceptButton': '.js-cookieBarAccept',
    'declineButton': '.js-cookieBarDecline',
    'resetButton': '.js-cookieBarReset',
    'secure': false,
    'path': '/',
    'domain': '',
    'threshold': 500
  }, options)

  const _hide = ($cookiebar) => {
    $cookiebar
      .attr('aria-hidden', 'true')
      .attr('aria-live', 'off')
      .hide()
  }

  const _show = ($cookiebar) => {
    $cookiebar
      .attr('aria-hidden', 'false')
      .attr('aria-live', 'polite')
      .show()
  }

  const _accept = function($cookiebar) {
    $.cookie('cookies_consent', 'true', {
      path: settings.path,
      secure: settings.secure,
      domain: settings.domain,
      expires: 30
    })
    $(document).trigger('accept.cookiebar', [$cookiebar])
  }

  const _decline = function($cookiebar) {
    $.cookie('cookies_consent', 'false', {
      path: settings.path,
      secure: settings.secure,
      domain: settings.domain,
      expires: 30
    })
    $(document).trigger('decline.cookiebar', [$cookiebar])
  }

  const _reset = function($cookiebar) {
	console.log($cookiebar)
    $.cookie('cookies_consent', '', {
      path: settings.path,
      secure: settings.secure,
      domain: settings.domain,
      expires: 0
    })
    $(document).trigger('reset.cookiebar', [$cookiebar])
  }

  $(document).on('accept.cookiebar', (e, $cookiebar) => {
    _hide($cookiebar)
  })

  $(document).on('decline.cookiebar', (e, $cookiebar) => {
    _hide($cookiebar)
  })

  $(document).on('reset.cookiebar', (e, $cookiebar) => {
    _show($cookiebar)
  })

  $.cookieBar = $.cookieBar || {}

  $.cookieBar.isChosen = function() {
    return $.cookie('cookies_consent') === 'true' || $.cookie('cookies_consent') === 'false'
  }

  return this.each(function() {
    var $cookiebar = $(this)

    if ($.cookieBar.isChosen()) {
      $('a' + settings.resetButton + '[href][aria-controls=' + $cookiebar.attr('id') + ']').each(function() {
    	$(this)
          .attr('href', '#')
      })
      $(settings.resetButton + '[aria-controls=' + $cookiebar.attr('id') + ']').each(function() {
    	$(this)
          .click(function() {
            _reset($cookiebar)
            return false
          })
        })
    } else {
      if (settings.threshold > 0) {
        $(window).on('scroll.cookiebar', (function() {
          if ($(window).scrollTop() > settings.threshold) {
            _hide($cookiebar)
          }
        }))
      }
      _show($cookiebar)
    }

    $cookiebar
      .find(settings.acceptButton)
      .click(function() {
        _accept($cookiebar)
        return false
      })

    $cookiebar
      .find(settings.declineButton)
      .click(function() {
        _decline($cookiebar)
        return false
      })

  })
}



// WEBPACK FOOTER //
// ./src/components/cookiebar/cookiebar.js